import React, { useState } from "react";
import { SectionHeader } from "./SectionHeader";

export const CaseStudies = ({ data, section }) => {
  const [active, setActive] = useState(null);
  const s = section || {};
  if (!data) return null;
  return (
    <div id="casestudies">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <SectionHeader heading={s.heading} subheading={s.subheading} />
          </div>
        </div>
        <div className="row">
          {data.map((d, i) => (
            <div key={i} className="col-md-4 case-study-card">
              <div className="case-study-inner">
                <div className="case-industry">{d.industry}</div>
                <div className="case-stat">{d.stat}</div>
                <div className="case-period">{d.period}</div>
                <p className="case-problem"><strong>Challenge:</strong> {d.problem}</p>
                <p className="case-solution"><strong>What we built:</strong> {d.solution}</p>
                {active === i && (
                  <div className="case-expanded">
                    <p className="case-result"><strong>Result:</strong> {d.result}</p>
                    <blockquote className="case-quote">
                      "{d.quote}"
                      <footer>{d.client}</footer>
                    </blockquote>
                  </div>
                )}
                <button
                  className="btn btn-custom btn-sm"
                  onClick={() => setActive(active === i ? null : i)}
                  style={{ marginTop: "12px" }}
                >
                  {active === i ? s.btn_collapse || "Show Less" : s.btn_expand || "Read Full Story →"}
                </button>
              </div>
            </div>
          ))}
        </div>
        {s.cta_label && (
          <div className="row text-center" style={{ marginTop: "30px" }}>
            <a href={s.cta_href || "#contact"} className="btn btn-custom btn-lg page-scroll">
              {s.cta_label}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
